var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50008 0.5H1.16675V15.5H12.8334V3.83333M9.50008 0.5L12.8334 3.83333M9.50008 0.5V3.83333H12.8334M10.3334 5.5H3.66675V12.1667M6.16675 12.1667V5.5M8.66675 12.1667V5.5M3.66675 8H10.3334M3.66675 10.5H10.3334",
    stroke: "#646D7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.d1ed8dd61726d768fc9fff7feb3805ac.svg";
export { ForwardRef as ReactComponent };